import { DefaultLayout as Layout } from '../../../layouts/Default/DefaultLayout';

export const NotFoundPage = () => {
  return (
    <Layout>
      <h1>Page Not Found</h1>
    </Layout>
  );
};
